<div class="orange-banner"></div>
<div class="password-forgot-container">
  <app-teaser></app-teaser>
  <app-password-forgotten></app-password-forgotten>
</div>